module.exports = __webpack_public_path__ + "img/img32.63688e49.png";